const headerMainContentHeightMobileNum = 48;
const headerQuickSearchHeightMobileNum = 52;
const headerTopContentHeightMobileNum = 26;

export const headerMainContentHeightMobile = `${headerMainContentHeightMobileNum}px`;
export const headerQuickSearchHeightMobile = `${headerQuickSearchHeightMobileNum}px`;
export const headerHeight = '145px';
export const headerHeightMobile =
headerTopContentHeightMobileNum + headerMainContentHeightMobileNum + headerQuickSearchHeightMobileNum + 'px';
